import { Grid, Paper } from '@material-ui/core'
import { Fragment, useState, useEffect } from 'react'
//import { AfterShowingStepProps } from '../ContractGeneratorStepper'
import ContractGeneratorForm from '../ContractGeneratorForm'

const ContractGeneratorSteps = ({
    currentStep,
    // apartment,
    classes,
    saveInstantRent,
    doStepBack,
    beforeLogin,
    isMobile,
    onTotalStepsChange,
}) => {
    const [totalSteps, setTotalSteps] = useState(3)
    useEffect(() => {
        if (onTotalStepsChange) {
            onTotalStepsChange(totalSteps)
        }
    }, [totalSteps, onTotalStepsChange])
    return (
        <Fragment>
            <Grid item sm={12} md={12}>
                <Paper className={classes.formPaper}>
                    <ContractGeneratorForm
                        classes={classes}
                        saveInstantRentForm={saveInstantRent}
                        currentStep={currentStep}
                        doStepBack={doStepBack}
                        beforeLogin={beforeLogin}
                        isMobile={isMobile}
                        numberOfSteps={setTotalSteps}
                    />
                </Paper>
            </Grid>
        </Fragment>
    )
}

export default ContractGeneratorSteps